import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import "./SubvendorDashboard.css";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { ILogin } from "../../../../models/Login";


interface IProps {
  open?: boolean,
  singleData?: any,
  setModel: (prev: { singleData: any, open: boolean }) => void,
  reload: () => void,
  modelData?: any
}

export const CompanyDetails = (props: IProps) => {
  const [model, setModel] = useState(false);
  const [companyDetails, setCompanyDetails] = useState<any>(null);

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

  const onHide = () => {
    setModel(false);
  };
  function handleJobDescription() {
    setModel(true);
  };

  return (
    <>
      <Card title={<p className="flex justify-content-between"><span>Company Details</span>{loginObj.user_Type === 3 ? <span className="pi pi-pencil mt-2" style={{ cursor: "pointer" }} onClick={() => props.setModel({ singleData: props.modelData, open: true })}></span> : <span></span>}</p>} style={{ marginBottom: "20px", backgroundColor: "#0093E9", backgroundImage: "linear-gradient(160deg, #0093E9 0%, #80D0C7 100%)", borderRadius: "10px", padding: "20px", color: "#F0F0F0", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", }}>
        <div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", }}>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Company Name :</strong>{" "}
            <span>{props?.modelData?.vendor_Company_Name}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Physical Address :</strong>{" "}
            <span>{props?.modelData?.street_Address || (`${props?.modelData?.state_Name || ""}, ${props?.modelData?.city_Name || ""}`)}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>FEID No. :</strong>{" "}
            <span>{props?.modelData?.vendor_Company_FidNo}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Website URL. :</strong>{" "}
            <span>{props?.modelData?.website_URL}</span>
          </p>
        </div>
      </Card>
    </>
  );
};
